import React from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { PhotoPresentationLayout } from './FocusPointEditor.types';

interface PhotoPresentationLayoutSelectorProps {
  currentPhotoLayout: PhotoPresentationLayout;
  onPhotoLayoutChange: (layout: PhotoPresentationLayout) => void;
}

interface LayoutOptionProps {
  isActive: boolean;
  onClick: (layout: PhotoPresentationLayout) => void;
  value: PhotoPresentationLayout;
  label: string;
}

const LayoutOption = (props: LayoutOptionProps) => {
  const { isActive, label, value, onClick } = props;
  return (
    <ButtonV2
      flex={1}
      padding={'10px'}
      intent="neutral"
      height="unset"
      borderWidth="1px"
      borderColor={isActive ? 'mono14' : 'mono5'}
      backgroundColor={isActive ? 'white' : 'mono2'}
      variant="outline"
      onClick={() => onClick(value)}
    >
      {label}
    </ButtonV2>
  );
};
export const PhotoPresentationLayoutSelector = (props: PhotoPresentationLayoutSelectorProps) => {
  const { currentPhotoLayout, onPhotoLayoutChange } = props;
  return (
    <Flex flexDirection="column" marginTop={7} rowGap={5}>
      <TextV2 typographyVariant={'hed2'}>Photo Layout</TextV2>
      <Flex columnGap={5}>
        <LayoutOption isActive={currentPhotoLayout === 'fullWidth'} label="Full Width Photo" onClick={onPhotoLayoutChange} value="fullWidth" />
        <LayoutOption isActive={currentPhotoLayout === 'center'} label="Centered Photo" onClick={onPhotoLayoutChange} value="center" />
      </Flex>
    </Flex>
  );
};
